
angular.module('bmsApp.directives')
	.directive('employeeProfile', function () {
		return {
			restrict: 'E',
			scope: {
				employee: '=',
				size: '='
			},
			replace: true,
			templateUrl: 'ng/shared/directives/stack0/employee-profile/employee-profile.html',
			link: function (scope) {
				if (!isNaN(parseInt(scope.size))) {
					scope.customSize = true;
				}
			}
		};
	});

